import { useState } from "react";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../../components/ui/dialog";
import { Plus } from "lucide-react";

const TerritoriesTab = ({ territories, onCreateTerritory }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [newTerritory, setNewTerritory] = useState({ name: "", country: "", currency: "EUR" });

  const handleCreate = async () => {
    await onCreateTerritory(newTerritory);
    setShowDialog(false);
    setNewTerritory({ name: "", country: "", currency: "EUR" });
  };

  return (
    <div className="bg-[#0B0F19] rounded-xl border border-[#D4AF37]/10 overflow-hidden">
      <div className="p-4 border-b border-[#D4AF37]/10 flex items-center justify-between">
        <h3 className="font-['Playfair_Display'] text-xl text-white">Territories</h3>
        <Dialog open={showDialog} onOpenChange={setShowDialog}>
          <DialogTrigger asChild>
            <Button className="btn-gold" data-testid="add-territory-btn">
              <Plus className="w-4 h-4 mr-2" />
              Add Territory
            </Button>
          </DialogTrigger>
          <DialogContent className="bg-[#0B0F19] border-[#D4AF37]/20 text-white">
            <DialogHeader>
              <DialogTitle className="font-['Playfair_Display'] text-xl">Add New Territory</DialogTitle>
            </DialogHeader>
            <div className="space-y-4 mt-4">
              <div>
                <Label className="text-white/70">Name</Label>
                <Input
                  value={newTerritory.name}
                  onChange={(e) => setNewTerritory({ ...newTerritory, name: e.target.value })}
                  className="bg-white/5 border-white/10 text-white mt-1"
                  placeholder="e.g. Barcelona"
                  data-testid="territory-name-input"
                />
              </div>
              <div>
                <Label className="text-white/70">Country</Label>
                <Input
                  value={newTerritory.country}
                  onChange={(e) => setNewTerritory({ ...newTerritory, country: e.target.value })}
                  className="bg-white/5 border-white/10 text-white mt-1"
                  placeholder="e.g. Spain"
                />
              </div>
              <div>
                <Label className="text-white/70">Currency</Label>
                <Select value={newTerritory.currency} onValueChange={(v) => setNewTerritory({ ...newTerritory, currency: v })}>
                  <SelectTrigger className="bg-white/5 border-white/10 text-white mt-1">
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="EUR">EUR (€)</SelectItem>
                    <SelectItem value="USD">USD ($)</SelectItem>
                    <SelectItem value="GBP">GBP (£)</SelectItem>
                  </SelectContent>
                </Select>
              </div>
              <Button onClick={handleCreate} className="btn-gold w-full" data-testid="save-territory-btn">
                Create Territory
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full" data-testid="territories-table">
          <thead className="bg-white/5">
            <tr>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Name</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Country</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Currency</th>
              <th className="text-left p-4 text-white/50 text-sm font-medium">Status</th>
            </tr>
          </thead>
          <tbody>
            {territories.map((t) => (
              <tr key={t.id} className="border-t border-white/5">
                <td className="p-4 text-white capitalize">{t.name}</td>
                <td className="p-4 text-white/70">{t.country}</td>
                <td className="p-4 text-[#D4AF37]">{t.currency}</td>
                <td className="p-4">
                  <span className={`px-2 py-1 rounded text-xs font-medium ${t.status === 'active' ? 'bg-[#047857]/20 text-[#047857]' : 'bg-white/10 text-white/40'}`}>
                    {t.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TerritoriesTab;
